/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getList.defs.js'
export * as $defs from './getList.defs.js'
